import React from "react";
import HeroSection from "../Components/HeroSection";

function Home() {
  return (
    <div>
      <HeroSection />
    </div>
  );
}

export default Home;
